<template>
  <div>
    <a-card class="card" :loading="loading">
      <tk-flex middle between>
        <tk-flex middle>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            fill="none"
            version="1.1"
            width="30"
            height="30"
            viewBox="0 0 30 30"
          >
            <defs>
              <linearGradient
                x1="0.5"
                y1="0"
                x2="0.5"
                y2="1"
                id="master_svg0_177_80147"
              >
                <stop offset="0%" stop-color="#01E678" stop-opacity="1" />
                <stop offset="100%" stop-color="#00D28B" stop-opacity="1" />
              </linearGradient>
              <clipPath id="master_svg1_395_027217">
                <rect x="5.625" y="5.625" width="18.75" height="18.75" rx="0" />
              </clipPath>
            </defs>
            <g>
              <g>
                <ellipse
                  cx="15"
                  cy="15"
                  rx="15"
                  ry="15"
                  fill="url(#master_svg0_177_80147)"
                  fill-opacity="1"
                />
              </g>
              <g clip-path="url(#master_svg1_395_027217)">
                <g>
                  <path
                    d="M22.6586,12.86329C22.6605,12.874369999999999,22.6631,12.88533,22.6664,12.8961C22.760199999999998,13.21485,22.8125,13.56562,22.8125,13.91874C22.8125,15.155470000000001,22.1953,16.28985,21.1984,16.883589999999998C20.7773,17.13437,20.2813,17.26328,19.718,17.26641C18.9604,17.26511,18.2327,16.97121,17.686700000000002,16.446089999999998C17.4947,16.26918,17.1991,16.26918,17.00704,16.446089999999998C16.46974,16.96601,15.75386,17.26062,15.00625,17.26952C14.25421,17.26275,13.533280000000001,16.968400000000003,12.99141,16.44688C12.80013,16.27113,12.50612,16.27113,12.31484,16.44688C11.76999,16.9715,11.04462,17.26707,10.28828,17.27265L10.28517,17.27265C9.73439,17.27265,9.24376,17.15077,8.82891,16.90702C7.8172,16.31953,7.1875,15.17891,7.1875,13.92891C7.1875,13.572659999999999,7.2390624,13.21954,7.342187,12.873429999999999C7.346875,12.84765,7.353137,12.825,7.357825,12.80469L7.363281,12.7875L8.78359,9.13281C9.00156,8.420306,9.60703,7.96875,10.385159999999999,7.96875L19.6539,7.96875C20.447699999999998,7.96875,21.0805,8.430469,21.3078,9.16954L22.630499999999998,12.75079C22.6418,12.78123,22.650399999999998,12.81259,22.6562,12.84454L22.6578,12.853909999999999C22.6578,12.85703,22.6578,12.86016,22.659399999999998,12.86329L22.6586,12.86329ZM7.968754,18.43745C7.968754,18.070349999999998,8.47656,17.86796,8.79218,18.05705L8.82891,18.07815C9.24297,18.321849999999998,9.73437,18.44455,10.28515,18.44455L10.28828,18.44455C11.044740000000001,18.43875,11.77013,18.14285,12.31485,17.61797C12.50614,17.442230000000002,12.80013,17.442230000000002,12.99141,17.61797C13.533280000000001,18.13945,14.25421,18.43385,15.00625,18.440649999999998C15.75413,18.43195,16.470309999999998,18.13725,17.00781,17.6172C17.1996,17.44124,17.4941,17.44124,17.6859,17.6172C18.2319,18.14235,18.959699999999998,18.43625,19.7172,18.43755C20.2813,18.434350000000002,20.7773,18.30545,21.1984,18.054650000000002C21.5141,17.86719,22.0313,18.06245,22.0313,18.43045L22.0313,20.46875C22.0313,21.76315,20.9819,22.81255,19.6875,22.81255L10.3125,22.81255C9.01809,22.81255,7.968754,21.76315,7.968754,20.46875L7.968754,18.43825L7.968754,18.43745Z"
                    fill="#FFFFFF"
                    fill-opacity="1"
                  />
                </g>
              </g>
            </g>
          </svg>
          <div class="p-l-12 font-15 font-bold">{{ warehouse.name }}</div>
        </tk-flex>
        <a-dropdown
          v-if="
            can('editGrainWarehouseModel') || can('deleteGrainWarehouseModel')
          "
        >
          <a-icon type="more" />
          <template #overlay>
            <a-menu>
              <a-menu-item
                @click="showEditFunc()"
                v-if="can('editGrainWarehouseModel')"
              >
                <div class="w-80p">编辑</div>
              </a-menu-item>
              <a-menu-item
                @click="showDele = true"
                v-if="can('deleteGrainWarehouseModel')"
              >
                <div class="color-red-del w-80p">删除</div>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </tk-flex>
      <a-row
        class="p-t-20 font-14 color-gray-card cursor-pointer"
        :gutter="[34, 20]"
        @click.native="$emit('click')"
      >
        <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="8" :xxl="6">
          <div class="color-gray-cardtitle">粮仓</div>
          <div>{{ allNum }}</div>
        </a-col>
        <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="8" :xxl="6">
          <div class="color-gray-cardtitle">有虫</div>
          <div>{{ haBugNUm }}</div>
        </a-col>
        <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="8" :xxl="6">
          <div class="color-gray-cardtitle">无虫</div>
          <div>{{ unBugNum }}</div>
        </a-col>
        <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="8" :xxl="6">
          <div class="color-gray-cardtitle">含虫量</div>
          <div>{{ formatCompact(bugsNum) }}</div>
        </a-col>
        <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="8" :xxl="6">
          <div class="color-gray-cardtitle">负责人</div>
          <div>{{ warehouse.wheelMan }}</div>
        </a-col>
        <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="8" :xxl="6">
          <div class="color-gray-cardtitle">负责人电话</div>
          <div>{{ warehouse.wheelManPhone }}</div>
        </a-col>
        <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="8" :xxl="6">
          <div class="color-gray-cardtitle">联系人</div>
          <div>{{ warehouse.contacter }}</div>
        </a-col>
        <a-col :xs="12" :sm="12" :md="12" :lg="12" :xl="8" :xxl="6">
          <div class="color-gray-cardtitle">联系人电话</div>
          <div>{{ warehouse.contacterPhone }}</div>
        </a-col>
        <a-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" :xxl="24">
          <div class="color-gray-cardtitle">地址</div>
          <div>{{ addressName + " " + warehouse.detailedAddress }}</div>
        </a-col>
      </a-row>
    </a-card>
    <a-modal
    :maskClosable="false"
      title="编辑粮库"
      :visible="showEdit"
      :confirm-loading="confirmEditLoading"
      @ok="handleEditOk"
      destroyOnClose
      @cancel="handleEditCancel"
    >
      <ak-inputs
        v-model="formdataedit"
        :options="optionsedit"
        ref="inputsedit"
      />
    </a-modal>
    <a-modal
      :maskClosable="false"
      :title="`确定要删除“${warehouse.name}”吗？`"
      :visible="showDele"
      destroyOnClose
      :confirm-loading="confirmDeleLoading"
      @ok="handleDeleOk"
      @cancel="handleDeleCancel"
    >
      <p>删除此粮库将无法恢复，您要继续吗？</p>
    </a-modal>
  </div>
</template>
<script>
import { notEmpty, isPhone } from '../../utils/validator'
import { formatCompact } from '../../utils/format.js'
import { mapGetters } from 'vuex'
import { getAddressAllAdcode } from '../../utils/adcode.js'
export default {
  props: {
    warehouse: {
      type: Object,
      required: true
    }
  },
  name: 'WarehouseCard',
  data () {
    return {
      unBugNum: 0,
      haBugNUm: 0,
      bugsNum: 0,
      loading: true,
      addressName: '',
      // delete modal
      showDele: false,
      confirmDeleLoading: false,
      // add modal
      optionsedit: [
        // {
        //   name: 'hierarchy',
        //   note: '所属层级',
        //   type: 'Pointer',
        //   validators: [notEmpty()],
        //   span: 24,
        //   targetClass: 'hierarchy',
        //   searchKey: ['name'],
        //   listWhere: where => {
        //     where.tag = {
        //       $regex: `^${this.userLevelTag}`
        //     }
        //   }
        // },
        {
          name: 'name',
          note: '粮库名称',
          type: 'String',
          validators: [notEmpty()]
        },
        {
          name: 'wheelMan',
          note: '负责人',
          type: 'String',
          validators: [notEmpty()]
        },
        {
          name: 'wheelManPhone',
          note: '负责人电话',
          type: 'String',
          validators: [notEmpty(), isPhone()]
        },
        {
          name: 'contacter',
          note: '联系人',
          type: 'String',
          validators: [notEmpty()]
        },
        {
          name: 'contacterPhone',
          note: '联系人电话',
          type: 'String',
          validators: [notEmpty(), isPhone()]
        },
        {
          name: 'address',
          note: '地址',
          type: 'Region',
          validators: [notEmpty()]
        },
        {
          name: 'detailedAddress',
          note: '详细地址',
          type: 'String',
          validators: [notEmpty()]
        }
      ],
      showEdit: false,
      confirmEditLoading: false,
      formdataedit: {
        ...this.warehouse
      }
    }
  },
  computed: {
    ...mapGetters(['userLevelTag']),
    allNum () {
      return this.unBugNum + this.haBugNUm
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    formatCompact,
    async init () {
      await Promise.all([this.getStatisticalData(), this.getAddressName()])
      this.loading = false
    },
    async getStatisticalData () {
      const unBug = this.$tkParse.get('/aggregate/grainStorehouse', {
        params: {
          group: {
            objectId: '', // 用来分组的字段，留空代表不分组
            total: {
              // total是自定义的名称，你可以用任何名字
              $sum: 1
            }
          },
          match: {
            grainWarehouse: this.warehouse.objectId,
            bugNum: 0
          } // 查询条件
        }
      })
      const hasBug = this.$tkParse.get('/aggregate/grainStorehouse', {
        params: {
          group: {
            objectId: '', // 用来分组的字段，留空代表不分组
            total: {
              // total是自定义的名称，你可以用任何名字
              $sum: 1
            },
            bugs: {
              $sum: '$bugNum'
            }
          },
          match: {
            grainWarehouse: this.warehouse.objectId,
            bugNum: { $gt: 0 }
          } // 查询条件
        }
      })
      const [unBugRes, hasBugRes] = await Promise.all([unBug, hasBug])
      this.unBugNum = unBugRes.data.results[0].total
      this.haBugNUm = hasBugRes.data.results[0].total
      this.bugsNum = hasBugRes.data.results[0].bugs || 0
    },
    async getAddressName () {
      const res = await this.$tkParse.get(
        `https://open-api.mokecloud.com/region?code=${this.warehouse.address}&fullname=true`
      )
      this.addressName = res.data[0].fullname
    },
    async handleDeleOk () {
      this.confirmDeleLoading = true
      const flag = await this.canDelete()
      if (flag) {
        await this.$tkParse.delete(
          `/classes/grainWarehouse/${this.warehouse.objectId}`
        )
        this.$emit('delete')
      } else {
        this.$notification['error']({
          message: '操作失败',
          description: '删除失败，此粮库下存在粮仓，请先将其移除'
        })
      }
      this.showDele = false
      this.confirmDeleLoading = false
    },
    async canDelete () {
      const res = await this.$tkParse.get('/classes/grainStorehouse', {
        params: {
          where: { grainWarehouse: this.warehouse.objectId }
        }
      })
      return res.data.results === 0
    },
    handleDeleCancel () {
      this.showDele = false
    },
    showEditFunc () {
      this.formdataedit = {
        ...this.warehouse
      }
      this.showEdit = true
    },
    async handleEditOk () {
      const errors = await this.$refs.inputsedit.validate()
      if (!Object.keys(errors).length) {
        this.confirmEditLoading = true
        const { cityCode, provinceCode } = await getAddressAllAdcode(this.formdataedit.address)
        await this.$tkParse.put(
          `/classes/grainWarehouse/${this.warehouse.objectId}`,
          {
            name: this.formdataedit.name,
            wheelMan: this.formdataedit.wheelMan,
            wheelManPhone: this.formdataedit.wheelManPhone,
            contacter: this.formdataedit.contacter,
            contacterPhone: this.formdataedit.contacterPhone,
            address: this.formdataedit.address,
            cityCode: cityCode,
            provinceCode: provinceCode,
            detailedAddress: this.formdataedit.detailedAddress
          }
        )
        this.showEdit = false
        this.confirmEditLoading = false
        this.$emit('edit')
      } else {
        throw new Error('input validate error')
      }
    },
    handleEditCancel () {
      this.showEdit = false
    }
  }
}
</script>

<style></style>
